import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { useAuth } from "@/hooks/useAuth";
import { useLanguage } from "@/contexts/LanguageContext";

const EmbedSettings = () => {
  const { profile } = useAuth();
  const { t } = useLanguage();
  const shopId = profile?.organisation_id || "YOUR_SHOP_ID";
  const embedCode = `<iframe src="${window.location.origin}/shop/${shopId}?embed=true" width="100%" height="700" frameborder="0"></iframe>`;

  const copyCode = () => {
    navigator.clipboard.writeText(embedCode);
    toast.success(t("embed.copied"));
  };

  return (
    <>
      <h1 className="text-xl font-bold text-foreground mb-6">{t("embed.title")}</h1>
      <section className="rounded-xl border border-border bg-card p-6 shadow-card">
        <p className="text-sm text-muted-foreground mb-3">{t("embed.desc")}</p>
        <div className="rounded-lg bg-muted p-3">
          <code className="text-xs text-foreground break-all">{embedCode}</code>
        </div>
        <Button variant="outline" className="mt-3" onClick={copyCode}>{t("embed.copy")}</Button>
      </section>
    </>
  );
};

export default EmbedSettings;
